import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/layout/Layout.vue";
import LayoutAllocation from "@/views/Allocation/Layout.vue";
// import adminRoutes from "./modules/admin";

Vue.use(VueRouter);
export const constantRoutes = [
    {
        path: "/",
        name: "Bienvenue",
        component: () => import("@/views/Bienvenue"),
        hidden: true
    },
    {
        path: "/stock",
        name: "Stock",
        component: LayoutAllocation,
        children: [
            {
                path: "/stock",
                name: "Stock",
                meta: {
                    title: "Mes Allocations",
                    icon: "box-open-solid",
                    noCache: true
                },
                component: () =>
                    import(
                        /* webpackChunkName: "stock" */ "@/views/Allocation/Stock"
                    )
            }
        ]
    },
    {
        path: "/404",
        redirect: "/",
        // component: () => import("@/views/error-page/404"),
        hidden: true
    },
    // plus de 'inscription'
    {
        path: "/inscription",
        name: "Inscription",
        component: () => import("@/views/Login.vue"),
        hidden: true
    },
    // à donner par mail
    {
        path: "/nouvelleinscription",
        name: "Inscription",
        component: () => import("@/views/Inscription"),
        hidden: true
    },
    {
        path: "/login",
        name: "Login",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(/* webpackChunkName: "login" */ "../views/Login.vue")
    },
    {
        path: "/allocataireprofile",
        component: LayoutAllocation,
        redirect: "/allocataireprofile/edit",
        hidden: true,
        children: [
            {
                path: "edit",
                component: () => import("@/views/users/SelfProfile"),
                name: "SelfProfile",
                meta: { title: "Profil", icon: "user", noCache: true }
            }
        ]
    }
];

export const asyncRoutes = [
    {
        path: "/dashboard",
        name: "dashboard",
        component: Layout,
        meta: { roles: ["admin"] },
        children: [
            {
                path: "/dashboard",
                name: "dashboard",
                meta: { title: "Dashboard", icon: "admin", noCache: true },
                component: () =>
                    import(
                        /* webpackChunkName: "dashboard" */ "@/views/Dashboard"
                    )
            }
        ]
    },
    {
        path: "/profile",
        component: Layout,
        redirect: "/profile/edit",
        hidden: true,
        meta: { roles: ["admin"] },
        children: [
            {
                path: "edit",
                component: () => import("@/views/users/SelfProfile"),
                name: "Profile",
                meta: { title: "Profil", icon: "user", noCache: true }
            }
        ]
    },
    {
        path: "/editstock",
        name: "editStock",
        component: LayoutAllocation,
        meta: { roles: ["admin"] },
        hidden: true,
        children: [
            {
                path: "/editstock/:id(\\d+)",
                name: "editStock",
                meta: {
                    title: "Edit Allocations",
                    icon: "box-open-solid",
                    noCache: true
                },
                component: () =>
                    import(
                        /* webpackChunkName: "stock" */ "@/views/Allocation/Stock"
                    )
            }
        ]
    },
    {
        path: "/externes",
        name: "ExterneList",
        component: Layout,
        meta: { roles: ["admin"] },
        children: [
            {
                path: "/externes",
                name: "ExterneList",
                meta: {
                    title: "Liste attente",
                    icon: "user",
                    noCache: true
                },
                props: {
                    role: "externe"
                },
                component: () => import("@/views/users/Users")
            },
            {
                path: "edit/:id(\\d+)",
                component: () => import("@/views/users/Profile"),
                name: "UserProfile",
                meta: {
                    title: "Profile",
                    noCache: true
                },
                hidden: true
            }
        ]
    },
    {
        path: "/allocataires",
        name: "allocataireList",
        component: Layout,
        meta: { roles: ["admin"] },
        children: [
            {
                path: "/allocataires",
                name: "AllocataireList",
                meta: {
                    title: "Allocataires",
                    icon: "user",
                    noCache: true
                },
                props: {
                    role: "allocataire"
                },
                component: () => import("@/views/users/Users")
            },
            {
                path: "edit/:id(\\d+)",
                component: () => import("@/views/users/Profile"),
                name: "UserProfile",
                meta: {
                    title: "Profile",
                    noCache: true
                },
                hidden: true
            }
        ]
    },
    {
        path: "/admins",
        name: "adminList",
        component: Layout,
        meta: { roles: ["admin"] },
        children: [
            {
                path: "/admins",
                name: "adminList",
                meta: {
                    title: "Admins",
                    icon: "user",
                    noCache: true
                },
                props: {
                    role: "admin"
                },
                component: () => import("@/views/users/Users")
            },
            {
                path: "edit/:id(\\d+)",
                component: () => import("@/views/users/Profile"),
                name: "UserProfile",
                meta: {
                    title: "userProfile",
                    noCache: true
                },
                hidden: true
            }
        ]
    },
    {
        path: "/bloques",
        name: "bloquesList",
        component: Layout,
        meta: { roles: ["admin"] },
        children: [
            {
                path: "/bloques",
                name: "bloquesList",
                meta: {
                    title: "Bloqués",
                    icon: "remove",
                    noCache: true
                },
                props: {
                    role: "bloqued"
                },
                component: () => import("@/views/users/Users")
            },
            {
                path: "edit/:id(\\d+)",
                component: () => import("@/views/users/Profile"),
                name: "UserProfile",
                meta: {
                    title: "userProfile",
                    noCache: true
                },
                hidden: true
            }
        ]
    },
    {
        path: "/bouteilles",
        name: "BouteillesList",
        component: Layout,
        meta: { roles: ["admin"] },
        children: [
            {
                path: "/bouteilles",
                name: "BouteillesList",
                meta: {
                    title: "Bouteilles",
                    noCache: true,
                    icon: "wine-bottle-solid"
                },
                component: () =>
                    import(
                        /* webpackChunkName: "bouteilles" */ "@/views/bouteilles/Bouteilles"
                    )
            }
        ]
    },
    {
        path: "/allocations",
        name: "AllocationsList",
        component: Layout,
        meta: { roles: ["admin"] },
        children: [
            {
                path: "/allocations",
                name: "AllocationsList",
                meta: {
                    title: "Allocations",
                    noCache: true,
                    icon: "box-open-solid"
                },
                component: () =>
                    import(
                        /* webpackChunkName: "allocations" */ "@/views/allocations/Allocations"
                    )
            }
        ]
    },
    {
        path: "/livreurs",
        name: "LivreurList",
        component: Layout,
        meta: { roles: ["admin"] },
        children: [
            {
                path: "/livreurs",
                name: "LivreurList",
                meta: {
                    title: "Livreurs",
                    noCache: true,
                    icon: "box-open-solid"
                },
                component: () =>
                    import(
                        /* webpackChunkName: "allocations" */ "@/views/livreurs/Livreurs"
                    )
            }
        ]
    },
    {
        path: "/carte",
        name: "Carte",
        component: Layout,
        meta: { roles: ["admin"] },
        children: [
            {
                path: "/carte",
                name: "Carte",
                meta: {
                    title: "Carte",
                    noCache: true,
                    icon: "admin"
                },
                component: () =>
                    import(
                        /* webpackChunkName: "allocations" */ "@/views/carte/Carte"
                    )
            }
        ]
    },
    {
        path: "/options",
        name: "OptionsList",
        component: Layout,
        meta: { roles: ["admin"] },
        children: [
            {
                path: "/options",
                name: "OptionsList",
                meta: {
                    title: "Options",
                    noCache: true,
                    icon: "admin"
                },
                component: () =>
                    import(
                        /* webpackChunkName: "allocations" */ "@/views/options/Options"
                    )
            }
        ]
    },
    { path: "*", redirect: "/404", hidden: true }
];

/*
const router = new VueRouter({
    mode: "history",
    base: "/",
    routes
});
*/
// export const asyncRoutes = [];

const createRouter = () =>
    new VueRouter({
        // mode: "history", // require service support
        mode: "history",
        scrollBehavior: () => ({ y: 0 }),
        base: "/",
        routes: constantRoutes
    });

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
    const newRouter = createRouter();
    router.matcher = newRouter.matcher; // reset router
}

export default router;
